module.exports = __webpack_public_path__ + "public/images/captcha-hexagon.da247b2794e14d53c8497ab625cca2c8.svg";